import React from "react";
import Typography from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import info from "../../../assets/summer/infographics.jpg";

const Details = () => {
  return (
    <>
      <Grid container margin={{ xs: "8% 0%", sm: "2% 0%" }}>
        <Grid xs={12} sm={6} paddingRight={"3%"}>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            On August 5, 2024, the Oluseun Onigbinde Resource Centre initiated a
            free 1-month summer coaching program for SS3 students in Ogbomoso.
            This program is tailored to help students build a solid academic
            foundation as they prepare for their SSCE exams. The coaching
            focuses on key subjects essential for success, including English,
            Mathematics, Physics, Chemistry, Biology, Financial Accounting,
            Economics, and Literature in English. Through this initiative, the
            Resource Centre aims to provide students with the academic support
            they need to excel in these critical examinations.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            The summer coaching sessions are taking place at Soun High School in
            Ogbomoso, with the program running until August 31, 2024. This
            intensive coaching is designed not only to reinforce students'
            understanding of their subjects but also to boost their confidence
            as they approach their final exams. The program includes interactive
            lessons, practice exercises, and personalized attention to address
            the specific needs of each student. By focusing on these areas, the
            Resource Centre is ensuring that students are thoroughly prepared
            for the challenges ahead.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            To further support the students, the program will culminate in an
            assessment to gauge their progress and readiness for the SSCE exams.
            Additionally, the Resource Centre is providing free exercise books
            to all participants, recognizing the importance of having adequate
            resources for effective study. This initiative is a testament to the
            Resource Centre's dedication to empowering young people through
            education, helping them overcome barriers, and providing them with
            the tools they need to succeed academically.
          </Typography>
        </Grid>
        <Grid xs={12} sm={6} display={{ xs: "none", sm: "block" }}>
          <Box
            component="img"
            height={{ xs: "95vh", sm: "650px" }}
            sx={{
              objectFit: "cover",
              width: "100%",
            }}
            src={info}
            alt={"image"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Details;
